import React from 'react';

interface BrandLogoProps {
  size?: number;
}

// CTrees gradient color leaf, served as a static asset from
// `public/ctrees-leaf.svg` (extracted from the marketing site). SVG so it
// stays crisp at any panel scale.
export const BrandLogo: React.FC<BrandLogoProps> = ({ size = 28 }) => (
  <img
    src="/ctrees-leaf.svg"
    alt="CTrees"
    style={{ height: size, width: 'auto' }}
  />
);
